<div>
    <p-toolbar>
        <button id="applyButton" pButton class="p-button-secondary" pRipple [label]="buttonText" (click)="onApplyInvoiceChanges()"></button>
        <button id="discardButton" pButton class="p-button-secondary" pRipple label="Discard Changes" (click)="onDiscardInvoiceChanges()"></button>
        <div>
            <label style="margin-left: .5em; margin-top: .5em; font-size: 14px; font-weight: bold;">{{this.dateText}}</label>
        </div>
    </p-toolbar>
    <p-table stripedRows #ContractsTable [scrollable]="true" [style]="{ 'max-width': '100%' }" scrollHeight="60vh" [loading]="loading"
        [value]="contracts" dataKey="ContractDesc" [virtualRowHeight]="10" [virtualScroll]="true" (onEditInit)="onEditInit($event)" (onEditComplete)="onEditComplete($event)">

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="17" style="text-align: center">
                    <div class="tabulator-placeholder">
                        <span> No Data Available... </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #header>
            <tr>
                <th style="width: 100%; justify-content: center; text-align: center;" class="colgroup" colspan="6">CONTRACTS SCHEDULED or WITH ACTIVITY - {{this.dateText}}</th>
            </tr>
            <tr>
                <th class="edit-cell">
                    <i class="pi pi-question-circle" title="Status"></i>
                </th>
                <th class="edit-cell">
                    Select To <br/> Invoice
                </th>
                <th class="edit-cell">
                    Has <br/> Schedule
                </th>
                <th class="edit-cell">
                    Period Is <br/> Invoiced
                </th>
                <th pSortableColumn="ContractDesc" style="padding-right: 8px !important; border-right: 0;">
                    Contract
                    <p-sortIcon field="" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="FPInvoiceAmount" style="margin-left: 3px !important">
                    Fixed Amount
                    <p-sortIcon field="" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order">
                    </p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template #body let-contract let-edit="editing">
            <tr [pEditableRow]="contract" data-id="row-{{ contract.ContractDesc }}" [pSelectableRow]="contract">
                <td class="edit-cell">
                    <a (click)="onStatusClick(contract)">
                        <div>
                            <ef-status-icon [status]="
                                    contract?.Status?.StatusCode
                                        " [message]="
                                        contract?.Status?.Message
                                        "></ef-status-icon>
                        </div>
                    </a>
                </td>
                <td class="edit-cell" >
                    <p-checkbox [disabled]="contract.CNListID != 'na' || contract.Contractinvoiced == true" binary="true" [(ngModel)]="contract.ContractSelected" (onChange)="onCheckboxChange($event, contract)"></p-checkbox>
                </td>
                <td class="edit-cell" >
                    <p-checkbox [disabled]="true" binary="true" [(ngModel)]="contract.Contractscheduled"></p-checkbox>
                </td>
                <td class="edit-cell" >
                    <p-checkbox [disabled]="true" binary="true" [(ngModel)]="contract.Contractinvoiced"></p-checkbox>
                </td>
                <td>
                    {{ contract.ContractDesc }}
                </td>
                <td [pEditableColumn]="contract">
                    <span *ngIf="+contract.FPInvoiceAmount != 0">
                        {{ currencyFormatter.format(+contract.FPInvoiceAmount) }}
                    </span>
                    <!-- <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input [disabled]="contract.CNListID == 'na'" pInputText type="text" [(ngModel)]="contract.FPInvoiceAmount"/>
                        </ng-template>
                        <ng-template pTemplate="output">
                            <span *ngIf="+contract.FPInvoiceAmount != 0">
                                {{ currencyFormatter.format(+contract.FPInvoiceAmount) }}
                            </span>
                        </ng-template>
                    </p-cellEditor> -->
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
